import React, { useEffect, useState } from "react";
import Dish from "./dish";
import axios from "axios";
import "./Menu.css";

function Menu() {
  const [allDishes, setAllDishes] = useState([]);
  const [categories, setCategories] = useState(["All"]);
  const [category, setCategory] = useState("All");

  useEffect(() => {
    axios
      .get("https://api.kafkaorostkaffee.com/dishes")
      .then((res) => {
        setAllDishes(res.data);

        // استخراج الكاتيجوريز بشكل ديناميكي
        const uniqueCategories = [
          "All",
          ...new Set(res.data.map((dish) => dish.category)),
        ];
        setCategories(uniqueCategories);
      })
      .catch((err) => console.error("Error fetching data:", err));
  }, []);

  const filteredDishes =
    category === "All"
      ? allDishes
      : allDishes.filter((dish) => dish.category === category);

  return (
    <div className="menu-container"
    style={{
        backgroundImage: "url(/assets/images/menu-bg.jpg)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        minHeight: "100vh",
      }}>
      {/* Logo */}
      <img
        src="/assets/images/logo.jpeg"
        alt="Logo"
        className="logo"
        onClick={() => (window.location.href = "/login")}
      />

      {/* أزرار التصنيفات */}
      <div className="category-buttons">
        {categories.map((cat) => (
          <button
            key={cat}
            className={category === cat ? "active" : ""}
            onClick={() => setCategory(cat)}
          >
            {cat.toUpperCase()}
          </button>
        ))}
      </div>

      {/* عرض الأطباق */}
      <div className="dishes-grid">
        {filteredDishes.map((dish) => (
          <Dish
  key={dish.id}
  imgurl={`https://api.kafkaorostkaffee.com${dish.image_url}`} // full URL
  title={dish.title}
  price={dish.price}
  desc={dish.description}
/>

        ))}
      </div>
    </div>
  );
}

export default Menu;
